<template>
    <div
        :class="[
            'form',
            'form__modulesform_item',
            `form__modulesform_item--${ moduleType }`,
            dragModeActive ? `dragactive` : '',
            dragStart ? 'dragstart' : '',
            dragEnter ? 'dragenter' : '',
            dragPosition ? `dragposition--${dragPosition}` : '',
            isNameEditable || isDescriptionEditable || isExternalIdEditable ? 'form__modulesform_item--edited' : ''
        ]"
    >
        <div class="form__modulesform_item_dropzone form__modulesform_item_dropzone--before"></div>
        <div class="form__modulesform_item_dragcover form__modulesform_item_dragcover--top"></div>
        <form-modulesform-item-line
            v-if="currentIndex === 0 && allowEdit && !disabled"
            :items="lineMenuList"
            :class="'form__modulesform_item_line--before'"
            :index="index"
            @emit-add="emitAdd"
        ></form-modulesform-item-line>
        <template v-if="false && moduleType === 'module'">
            <div class="form__modulesform_item_above">
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <form-checkbox
                            :disabled="true || (!allowEdit && !isNameEditable && !isDescriptionEditable && !isExternalIdEditable)"
                            :label="''"
                            :switcher="true"
                            :switcher-text-active="'mandatory'"
                            :switcher-text-inactive="'mandatory'"
                            :name="`form-module-form-${index}`"
                            :value="moduleRequired"
                            @input="performSaveModuleRequired"
                        ></form-checkbox>
                    </div>
                </div>
            </div>
        </template>
        <div :class="[
            'form__modulesform_item_top'
        ]">
            <div class="columns fullheight is-vcentered is-variable is-0">
                <div class="column is-narrow">
                    <div class="form__modulesform_item_top_left">
                        <div class="columns fullheight">
                            <div class="column is-narrow">
                                <div class="form__modulesform_item_top_left_dragdrop">
                                    <component-button
                                        :class="'form__modulesform_item_top_left_dragdrop_button'"
                                        :name="`form-modulesform-dragdrop-button-${index.join('-')}`"
                                        :icon="true"
                                        :disabled="!allowEdit"
                                        :icon-name="'more-vertical'"
                                        :icon-raw="true"
                                        :icon-duplicate="true"
                                        :fullheight="true"
                                        :theme="''"
                                        :draggable="allowEdit ? true : false"
                                    ></component-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="form__modulesform_item_top_right">
                        <div class="columns is-variable">
                            <template v-if="moduleType === 'group'">
                                <div class="column is-narrow">
                                    <div class="columns fullheight is-vcentered">
                                        <div class="column">
                                            <div class="form__modulesform_item_top_right_toggle">
                                                <component-button
                                                    v-if="!moduleNewModule"
                                                    :class="'form__modulesform_item_top_right_toggle_button'"
                                                    :name="`form-modulesform-toggle-button-${index.join('-')}`"
                                                    :icon="true"
                                                    :icon-name="isMainBoxActive ? 'chevron-down' : 'chevron-right'"
                                                    :icon-raw="true"
                                                    :theme="''"
                                                    @click="switchMainBox"
                                                ></component-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="column">
                                <div class="form__modulesform_item_top_right_label">
                                    <template v-if="moduleType === 'module' && moduleSubType === 'event' && (isExternalIdEditable || moduleNewModule)">
                                        <div class="columns is-vbottom">
                                            <div class="column">
                                                <form-select
                                                    :data-vv-as="'module'"
                                                    :data-vv-scope="`module-form-${index.join('-')}`"
                                                    :disabled="isGetItemsPending || !moduleNewModule"
                                                    :get-pagination-getter="'getEventsPagination'"
                                                    :get-items-getter="'getEventsMappedIdNameStatus'"
                                                    :get-items-getter-mapped="'getEventsMappedLabelValue'"
                                                    :get-items-dispatch="'getEvents'"
                                                    :item-name="['event', 'events']"
                                                    :label="''"
                                                    :name="`form-modulesform-top-right-field-externalid-${moduleType}-${index.join('-')}`"
                                                    :search-queryable="true"
                                                    :table-labels="[
                                                        {
                                                            key: 'name',
                                                            title: 'Name',
                                                            type: 'string',
                                                            sortable: true,
                                                            queryable: true
                                                        },
                                                        {
                                                            key: 'status',
                                                            title: 'Status',
                                                            type: 'string',
                                                            sortable: true,
                                                            queryable: true
                                                        }
                                                    ]"
                                                    :v-validate="{ required: true }"
                                                    :value="moduleExternalId"
                                                    :prevent-clear="true"
                                                    @input="setModuleExternalId"
                                                    @input-table="setModuleExternalId"
                                                ></form-select>
                                            </div>
                                            <div class="column is-narrow">
                                                <component-button
                                                    :name="`form-modulesform-confirm-button-${index.join('-')}`"
                                                    :animate-loading="true"
                                                    :animate-loading-event-name="'save-module'"
                                                    :disabled="!moduleExternalId"
                                                    @click="performSaveModuleExternalId"
                                                >Confirm
                                                </component-button>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="moduleType === 'module' && moduleSubType === 'scorm' && (isExternalIdEditable || moduleNewModule)">
                                        <div class="columns is-vbottom">
                                            <div class="column">
                                                <form-select
                                                    :data-vv-as="'module'"
                                                    :data-vv-scope="`module-form-${index.join('-')}`"
                                                    :disabled="isGetItemsPending || !moduleNewModule"
                                                    :get-pagination-getter="'getEbsModulesPagination'"
                                                    :get-items-getter="'getEbsModulesMappedIdNameVersionLabels'"
                                                    :get-items-getter-mapped="'getEbsModulesMappedLabelValue'"
                                                    :get-items-dispatch="'ebsModulesGetSCORMReleased'"
                                                    :item-name="['SCORM', 'SCORMS']"
                                                    :label="''"
                                                    :name="`form-modulesform-top-right-field-externalid-${moduleType}-${index.join('-')}`"
                                                    :search-queryable="true"
                                                    :table-labels="[
                                                        {
                                                            key: 'name',
                                                            title: 'Name',
                                                            type: 'string',
                                                            sortable: true,
                                                            queryable: true
                                                        },
                                                        {
                                                            key: 'version',
                                                            title: 'Version',
                                                            type: 'string',
                                                            sortable: false,
                                                            queryable: false
                                                        },
                                                        {
                                                            key: 'labels',
                                                            title: 'Labels',
                                                            type: 'string',
                                                            sortable: false,
                                                            queryable: false
                                                        }
                                                    ]"
                                                    :pop-table-filter-select-active="true"
                                                    :pop-table-filter-select-items="modulesFiltersSelect"
                                                    :v-validate="{ required: true }"
                                                    :value="moduleExternalId"
                                                    :prevent-clear="true"
                                                    @input="setModuleExternalId"
                                                    @input-table="setModuleExternalId"
                                                ></form-select>
                                            </div>
                                            <div class="column is-narrow">
                                                <component-button
                                                    :name="`form-modulesform-confirm-button-${index.join('-')}`"
                                                    :animate-loading="true"
                                                    :animate-loading-event-name="'save-module'"
                                                    :disabled="!moduleExternalId"
                                                    @click="performSaveModuleExternalId"
                                                >Confirm
                                                </component-button>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="columns is-variable is-2 form__modulesform_item_top_right_label--columns">
                                            <div class="column form__modulesform_item_top_right_label--column-centered">
                                                <div class="form__modulesform_item_top_right_label_field">
                                                    <template v-if="moduleType === 'note'">
                                                        <component-text
                                                            :class="'form__modulesform_item_top_right_label_type'"
                                                            :size="'small'"
                                                        >Note
                                                        </component-text>
                                                        <template v-if="!isDescriptionEditable && moduleDescription">
                                                            <div
                                                                @click="performEnableDescriptionEditable"
                                                                class="form__modulesform_item_top_right_label_name"
                                                            >
                                                                {{ moduleDescription }}
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <form-textarea
                                                                        :label="''"
                                                                        :name="`form-modulesform-top-right-field-description-${moduleType}-${index.join('-')}`"
                                                                        :placeholder="'Some nice note'"
                                                                        :v-validate="{ required: true }"
                                                                        :data-vv-as="'note'"
                                                                        :data-vv-scope="`module-form-${index.join('-')}`"
                                                                        :value="moduleDescription"
                                                                        @input="setModuleDescription"
                                                                    ></form-textarea>
                                                                </div>
                                                                <div class="column is-narrow">
                                                                    <component-button
                                                                        :name="`form-modulesform-confirm-button-${index.join('-')}`"
                                                                        :animate-loading="true"
                                                                        :animate-loading-event-name="'save-module'"
                                                                        :disabled="!moduleDescription"
                                                                        @click="performSaveNoteDescription"
                                                                    >Confirm
                                                                    </component-button>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="moduleType === 'group'">
                                                        <component-text
                                                            :class="'form__modulesform_item_top_right_label_type'"
                                                            :size="'small'"
                                                        >Section
                                                        </component-text>
                                                        <template v-if="!isNameEditable && moduleName">
                                                            <div
                                                                @click="performEnableNameEditable"
                                                                class="form__modulesform_item_top_right_label_name"
                                                            >{{ moduleName }}
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <form-text
                                                                        :label="''"
                                                                        :name="`form-modulesform-top-right-field-name-${moduleType}-${index.join('-')}`"
                                                                        :placeholder="'Name'"
                                                                        :v-validate="{ required: true }"
                                                                        :data-vv-as="'name'"
                                                                        :data-vv-scope="`module-form-${index.join('-')}`"
                                                                        :value="moduleName"
                                                                        @input="setModuleName"
                                                                    ></form-text>
                                                                </div>
                                                                <div class="column is-narrow">
                                                                    <component-button
                                                                        :name="`form-modulesform-confirm-button-${index.join('-')}`"
                                                                        :animate-loading="true"
                                                                        :animate-loading-event-name="'save-module'"
                                                                        :disabled="!moduleName"
                                                                        @click="performSaveGroupName"
                                                                    >Confirm
                                                                    </component-button>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="moduleType === 'module'">
                                                        <component-text
                                                            :class="'form__modulesform_item_top_right_label_type'"
                                                            :size="'small'"
                                                        >{{ moduleSubType === 'scorm' ? 'SCORM' : 'Event' }}
                                                        </component-text>
                                                        <template v-if="!isNameEditable && moduleName">
                                                            <div
                                                                v-on="moduleSubType === 'scorm' ? { 'click' : performEnableNameEditable } : {}"
                                                                class="form__modulesform_item_top_right_label_name"
                                                            >{{ moduleName }}
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <form-text
                                                                        :label="''"
                                                                        :name="`form-modulesform-top-right-field-name-${moduleType}-${index.join('-')}`"
                                                                        :placeholder="'Name'"
                                                                        :v-validate="{ required: true }"
                                                                        :data-vv-as="'name'"
                                                                        :data-vv-scope="`module-form-${index.join('-')}`"
                                                                        :value="moduleName"
                                                                        @input="setModuleName"
                                                                    ></form-text>
                                                                </div>
                                                                <div class="column is-narrow">
                                                                    <component-button
                                                                        :name="`form-modulesform-confirm-button-${index.join('-')}`"
                                                                        :animate-loading="true"
                                                                        :animate-loading-event-name="'save-module'"
                                                                        :disabled="!moduleName"
                                                                        @click="performSaveModuleName"
                                                                    >Confirm
                                                                    </component-button>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="column is-narrow">
                                <div class="form__modulesform_item_top_right_dots">
                                    <component-button-menu
                                        ref="modulemoremenu"
                                        :disabled="!allowEdit && !isNameEditable && !isDescriptionEditable && !isExternalIdEditable"
                                        :name="`form-modulesform-dots-button-${index.join('-')}`"
                                        :icon-name="'more-horizontal'"
                                        :theme="'default'"
                                        :buttons="buttonMenuList"
                                        @emit-show-module="performEnableExternalIdEditable"
                                        @emit-edit-name="enableNameEditable"
                                        @emit-add-module="emitAdd({ type: 'module', index: [...index, 0] })"
                                        @emit-preview="performPreviewSCORMModule"
                                        @emit-remove="emitRemove({ moduleId, index, newModule: moduleNewModule })"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="moduleType === 'group'">
            <div
                v-show="isMainBoxActive"
                :class="[
                    'form__modulesform_item_main',
                    moduleModules.length === 0 ? 'form__modulesform_item_main--empty' : ''
                ]"
            >
                <template v-if="moduleModules.length === 0">
                    <form-modulesform-item-line
                        v-if="allowEdit && !disabled"
                        :items="lineMenuList"
                        :class="'form__modulesform_item_line--zero'"
                        :index="[...index, 0]"
                        @emit-add="emitAdd"
                    ></form-modulesform-item-line>
                    <div class="form__modulesform_item_dropzone form__modulesform_item_dropzone--zero"></div>
                    <div class="form__modulesform_item_dragcover form__modulesform_item_dragcover--zero"></div>
                </template>
                <form-modulesform
                    :disabled="disabled"
                    :modules="moduleModules"
                    :index="index"
                    @emit-add="emitAdd"
                    @emit-remove="emitRemove"
                    @emit-move="emitMove"
                ></form-modulesform>
            </div>
        </template>
        <form-modulesform-item-line
            v-if="allowEdit && !disabled"
            :items="lineMenuList"
            :class="'form__modulesform_item_line--after'"
            :index="index"
            @emit-add="emitAdd(...arguments, true)"
        ></form-modulesform-item-line>
        <div class="form__modulesform_item_dragcover form__modulesform_item_dragcover--bottom"></div>
        <div class="form__modulesform_item_dropzone form__modulesform_item_dropzone--after"></div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import FormSelect from '@/components/default/forms/FormSelect'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormModulesformItemLine from '@/components/default/forms/FormModulesformItemLine'
import FormText from '@/components/default/forms/FormText'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'form-modulesform-item',
  data () {
    return {
      isMainBoxActive: true,
      isNameEditable: false,
      isExternalIdEditable: false,
      isDescriptionEditable: false,
      isGetItemsPending: false,
      isRequestPending: false,
      dragStart: false,
      dragEnter: false,
      dragPosition: ''
    }
  },
  components: {
    ComponentText,
    FormModulesform: () => import('@/components/default/forms/FormModulesform'),
    FormText,
    FormModulesformItemLine,
    FormTextarea,
    FormSelect,
    FormCheckbox,
    ComponentButtonMenu,
    ComponentButton
  },
  props: {
    index: {
      type: Array,
      default: () => []
    },
    module: {
      type: [Array, Object],
      required: true
    },
    dragModeActive: {
      type: Boolean,
      default: false
    },
    dragItem: {
      type: Object,
      default: () => {
      }
    },
    isAnyEditable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allowEdit () {
      return this.$store.getters.getEbsCourseAllowEdit && !this.disabled && !this.isRequestPending && !this.isAnyEditable
    },
    currentIndex () {
      return JSON.parse(JSON.stringify(this.index)).pop()
    },
    moduleType () {
      return this.module.type
    },
    moduleSubType () {
      return this.module.subType
    },
    moduleName () {
      return this.module.name
    },
    moduleId () {
      return this.module.id
    },
    moduleModuleId () {
      return this.module.moduleId
    },
    moduleDescription () {
      return this.module.description
    },
    moduleExternalId () {
      return this.moduleNewModule ? this.module.id : this.module.externalId
    },
    moduleModules () {
      return this.module.nodes
    },
    moduleNewModule () {
      return Boolean(this.module.newModule)
    },
    moduleRequired () {
      return this.module.required
    },
    rawItems () {
      const moduleType = this.moduleType
      let getterName

      switch (moduleType) {
        case 'module':
          getterName = 'getEventsMappedLabelValue'
      }

      return this.$store.getters[getterName]
    },
    buttonMenuList () {
      let listArr = []
      let moduleType = this.moduleType
      let moduleSubType = this.moduleSubType

      if (this.allowEdit) {
        if (moduleType === 'group') {
          listArr.push({
            key: 'edit-name',
            name: 'Edit section name'
          })
          listArr.push({
            key: 'add-module',
            name: 'Add module'
          })
        } else if (moduleSubType === 'scorm') {
          listArr.push({
            key: 'preview',
            name: 'Preview'
          })
        }
      }
      listArr.push({
        key: 'remove',
        name: 'Remove'
      })

      return listArr
    },
    lineMenuList () {
      let listArr = []

      listArr.push({
        key: 'module',
        subKey: 'scorm',
        name: 'SCORM'
      })
      listArr.push({
        key: 'module',
        subKey: 'event',
        name: 'Event'
      })
      if (this.index.length < 4) {
        listArr.push({
          key: 'group',
          name: 'Section'
        })
      }
      listArr.push({
        key: 'note',
        name: 'Note'
      })

      return listArr
    },
    modulesFiltersSelect () {
      return [
        {
          key: 'labels',
          label: 'Labels',
          type: 'multiselect',
          getItemsGetter: 'getEbsModuleCustomLabelsMappedIdNameStatus',
          getItemsGetterMapped: 'getEbsModuleCustomLabelsMappedLabelValue',
          getItemsDispatch: 'ebsModuleGetLabels',
          getPaginationGetter: 'getEbsModuleCustomLabelsPagination',
          itemName: ['label', 'labels'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        }
      ]
    }
  },
  methods: {
    enableMainBox () {
      this.isMainBoxActive = true
    },
    disableMainBox () {
      this.isMainBoxActive = false
    },
    switchMainBox () {
      this.isMainBoxActive = !this.isMainBoxActive
    },
    enableNameEditable () {
      this.$eventBus.$emit('form-modules-enable-name-editable')
      this.isNameEditable = true
    },
    disableNameEditable () {
      this.$eventBus.$emit('form-modules-disable-name-editable')
      this.isNameEditable = false
    },
    enableExternalIdEditable () {
      this.$eventBus.$emit('form-modules-enable-externalid-editable')
      this.isExternalIdEditable = true
    },
    disableExternalIdEditable () {
      this.$eventBus.$emit('form-modules-disable-externalid-editable')
      this.isExternalIdEditable = false
    },
    enableDescriptionEditable () {
      this.$eventBus.$emit('form-modules-enable-description-editable')
      this.isDescriptionEditable = true
    },
    disableDescriptionEditable () {
      this.$eventBus.$emit('form-modules-disable-description-editable')
      this.isDescriptionEditable = false
    },
    performEnableNameEditable () {
      if (!this.isAnyEditable && this.allowEdit) {
        this.enableNameEditable()
      }
    },
    performEnableDescriptionEditable () {
      if (!this.isAnyEditable && this.allowEdit) {
        this.enableDescriptionEditable()
      }
    },
    performEnableExternalIdEditable () {
      if (this.allowEdit) {
        this.getModule(this.moduleModuleId).finally(() => {
          this.enableExternalIdEditable()
        })
      }
    },
    //
    emitAdd (data, after) {
      let objectData = data
      objectData.after = after !== undefined ? after : objectData.after
      this.$emit('emit-add', objectData)
      this.enableMainBox()
    },
    emitRemove (data) {
      this.$emit('emit-remove', data)
    },
    emitMove (data) {
      this.$emit('emit-move', data)
    },
    performSaveNoteDescription () {
      let dispatchName = this.moduleNewModule ? 'ebsCourseInsertNote' : 'ebsCourseUpdateNoteDetails'
      let dispatchParameters = this.moduleNewModule ? { description: this.moduleDescription, index: this.index } : { moduleId: this.moduleId, description: this.moduleDescription }
      this.$validator.validate(`form-modulesform-top-right-field-description-${this.moduleType}-${this.index.join('-')}`).then((result) => {
        if (result) {
          if (this.moduleType === 'note') {
            this.isRequestPending = true
            this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
            }).finally(() => {
              this.$eventBus.$emit('stop-save-module')
              this.disableDescriptionEditable()
              this.isRequestPending = false
            })
          }
        } else {
          this.$eventBus.$emit('stop-save-module')
        }
      })
    },
    performSaveGroupName () {
      let dispatchName = this.moduleNewModule ? 'ebsCourseInsertGroup' : 'ebsCourseUpdateGroupDetails'
      let dispatchParameters = this.moduleNewModule ? { name: this.moduleName, index: this.index } : { moduleId: this.moduleId, name: this.moduleName }
      this.$validator.validate(`form-modulesform-top-right-field-name-${this.moduleType}-${this.index.join('-')}`).then((result) => {
        if (result) {
          this.isRequestPending = true
          this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
          }).finally(() => {
            this.$eventBus.$emit('stop-save-module')
            this.disableNameEditable()
            this.isRequestPending = false
          })
        } else {
          this.$eventBus.$emit('stop-save-module')
        }
      })
    },
    performSaveModuleExternalId () {
      if (this.moduleNewModule) {
        let dispatchName = 'ebsCoursePerformInsertModule'
        let dispatchParameters = { name: this.moduleName, id: this.moduleExternalId, required: this.moduleRequired, type: this.moduleSubType, index: this.index }
        this.$validator.validate(`form-modulesform-top-right-field-externalid-${this.moduleType}-${this.index.join('-')}`).then((result) => {
          if (result) {
            this.isRequestPending = true
            this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
            }).finally(() => {
              this.$eventBus.$emit('stop-save-module')
              this.disableExternalIdEditable()
              this.isRequestPending = false
            })
          } else {
            this.$eventBus.$emit('stop-save-module')
          }
        })
      } else {
        this.disableExternalIdEditable()
      }
    },
    performSaveModuleName () {
      let dispatchName = 'ebsCourseUpdateModuleDetails'
      let dispatchParameters = { moduleId: this.moduleId, name: this.moduleName, required: this.moduleRequired }
      this.$validator.validate(`form-modulesform-top-right-field-name-${this.moduleType}-${this.index.join('-')}`).then((result) => {
        if (result) {
          if (this.moduleNewModule) {
            this.disableNameEditable()
            this.enableExternalIdEditable()
          } else {
            this.isRequestPending = true
            this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
            }).finally(() => {
              this.$eventBus.$emit('stop-save-module')
              this.disableNameEditable()
              this.isRequestPending = false
            })
          }
        } else {
          this.$eventBus.$emit('stop-save-module')
        }
      })
    },
    performSaveModuleRequired (value) {
      if (this.moduleNewModule) {
        this.setModuleRequired(value)
      } else {
        let dispatchName = 'ebsCourseUpdateModuleRequired'
        let dispatchParameters = { moduleId: this.moduleModuleId, name: this.moduleName }
        this.isRequestPending = true
        this.$store.dispatch(dispatchName, dispatchParameters).finally(response => {
          this.$eventBus.$emit('stop-save-module')
          this.isRequestPending = false
        })
      }
    },
    performPreviewSCORMModule () {
      this.$store.dispatch('ebsModuleGetSCORM', this.moduleExternalId).then(response => {
        const routeData = this.$router.resolve({ name: 'ebs-module-iframe-scorm', params: { id: response.content } })
        window.open(routeData.href, '_blank')
      })
    },
    setModuleName (value) {
      this.$store.dispatch('ebsCourseSetModuleValue', { key: 'name', value: value, index: this.index })
    },
    setModuleDescription (value) {
      this.$store.dispatch('ebsCourseSetModuleValue', { key: 'description', value: value, index: this.index })
    },
    setModuleExternalId (value) {
      this.$store.dispatch('ebsModuleSetExternalModuleExternalId', value.value)
      this.$store.dispatch('ebsCourseSetModuleValue', { key: 'name', value: value.name || value.customLabel, index: this.index })
      this.$store.dispatch('ebsCourseSetModuleValue', { key: 'id', value: value.value, index: this.index })
    },
    setModuleRequired (value) {
      this.$store.dispatch('ebsCourseSetModuleValue', { key: 'required', value: value, index: this.index })
    },
    //
    handleDragStart (event) {
      this.$eventBus.$emit('form-modules-dragstart', { index: this.index, type: this.moduleType })
      this.dragStart = true
    },
    handleDragEnter (event, position) {
      this.$eventBus.$emit('form-moduleform-disable-dragenter')
      setTimeout(() => {
        this.dragEnter = true
        this.dragPosition = position
      }, 1)
    },
    handleDragLeave (event) {
      this.dragEnter = false
      this.dragPosition = ''
    },
    handleDragEnd (event) {
      this.$eventBus.$emit('form-modules-dragend')
      this.dragStart = false
    },
    handleDragOver (event) {
      event.preventDefault()
    },
    handleDrop (event, position) {
      this.dragEnter = false
      this.emitMove({ from: this.dragItem.index, to: this.index, type: this.dragItem.type, position: position })
    },
    initializeDragDrop () {
      let dragItem = this.$el.getElementsByClassName('form__modulesform_item_top_left_dragdrop_button')
      let dragCoverTop = this.$el.getElementsByClassName('form__modulesform_item_dragcover--top')
      let dragCoverBottom = this.$el.getElementsByClassName('form__modulesform_item_dragcover--bottom')
      let dragCoverZero = this.$el.getElementsByClassName('form__modulesform_item_dragcover--zero')

      if (dragItem.length) {
        dragItem = dragItem[0]
        dragItem.addEventListener('dragstart', this.handleDragStart)
        dragItem.addEventListener('dragend', this.handleDragEnd)
      }
      if (dragCoverTop.length) {
        dragCoverTop = dragCoverTop[0]
        dragCoverTop.addEventListener('dragenter', () => this.handleDragEnter(event, 'before'))
        dragCoverTop.addEventListener('dragleave', this.handleDragLeave)
        dragCoverTop.addEventListener('dragover', this.handleDragOver)
        dragCoverTop.addEventListener('drop', () => this.handleDrop(event, 'before'))
      }
      if (dragCoverBottom.length) {
        dragCoverBottom = dragCoverBottom[dragCoverBottom.length - 1]
        dragCoverBottom.addEventListener('dragenter', () => this.handleDragEnter(event, 'after'))
        dragCoverBottom.addEventListener('dragleave', this.handleDragLeave)
        dragCoverBottom.addEventListener('dragover', this.handleDragOver)
        dragCoverBottom.addEventListener('drop', () => this.handleDrop(event, 'after'))
      }
      if (dragCoverZero.length) {
        dragCoverZero = dragCoverZero[0]
        dragCoverZero.addEventListener('dragenter', () => this.handleDragEnter(event, 'zero'))
        dragCoverZero.addEventListener('dragleave', this.handleDragLeave)
        dragCoverZero.addEventListener('dragover', this.handleDragOver)
        dragCoverZero.addEventListener('drop', () => this.handleDrop(event, 'zero'))
      }
    },
    initializeAddListeners () {
      this.$eventBus.$on('emit-open-all-groups', this.enableMainBox)
      this.$eventBus.$on('emit-close-all-groups', this.disableMainBox)
    },
    initializeRemoveListeners () {
      this.$eventBus.$off('emit-open-all-groups', this.enableMainBox)
      this.$eventBus.$off('emit-close-all-groups', this.disableMainBox)
    },
    initializeEditableFields () {
      if (this.moduleType === 'group' && this.moduleNewModule) {
        this.enableNameEditable()
        this.disableMainBox()
      } else if (this.moduleType === 'module' && this.moduleNewModule) {
        this.enableExternalIdEditable()
      } else if (this.moduleType === 'scorm' && this.moduleNewModule) {
        this.enableExternalIdEditable()
      } else if (this.moduleType === 'note' && this.moduleNewModule) {
        this.enableDescriptionEditable()
      }
    },
    initializeAddDragEnterListener () {
      this.$eventBus.$on('form-moduleform-disable-dragenter', () => {
        this.dragEnter = false
      })
    },
    initializeRemoveDragEnterListener () {
      this.$eventBus.$off('form-moduleform-disable-dragenter')
    },
    getModule (id) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('ebsModuleGet', id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  mounted () {
    this.initializeAddDragEnterListener()
    this.initializeEditableFields()
    this.initializeDragDrop()
    this.initializeAddListeners()
  },
  updated () {
    this.initializeEditableFields()
    this.initializeDragDrop()
    this.initializeRemoveDragEnterListener()
    this.initializeRemoveListeners()
    this.initializeAddListeners()
    this.initializeAddDragEnterListener()
  },
  beforeDestroy () {
    this.initializeRemoveDragEnterListener()
    this.initializeRemoveListeners()
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formmoduleformitem";
</style>
